<template>
	<div id="newQianniuex">
		<div @click="back" style="display: flex;flex-direction: row;align-items: center;margin-bottom: 10px;cursor: pointer; width: 100px;">
            <i class="el-icon-arrow-left"></i>
            <div style="margin-left: 10px;">返回</div>
        </div>
		<el-tabs tab-position="left" v-model="tabCurrent" @tab-click="handleClick">
			<!--第0步 通关必看-->
            <el-tab-pane name="zero">
                <div slot="label" class="tab-slot">
                    <p class="title">通关必看</p>
                    <div class="hover-con">
                        <p><i class="el-icon-video-play"></i></p>
                        <p>点击学习</p>
                    </div>
                </div>
                <div id="startvideo" class="startvideo">
                    <div class="tip" style="width:290px;">
                        <p><i class="el-icon-video-play"></i></p>
                        <p>
                            <a class="startstudy" @click="startVideo">开始学习</a>
                        </p>
                    </div>
                </div>
                <div id="video-zero" class="video-box">
                    <video id="zero"
                        src="http://taojinyun.file.itaojin.cn/qianniusource/202412/%E9%80%9A%E5%85%B3%E5%BF%85%E7%9C%8B.mp4"
                        controls="controls" class="video">
                        您的浏览器不支持 video 标签。
                    </video>
					<div class="video-mask"></div>
                </div>
                <div id="stoptip-zero" class="stoptip">
                    <div class="tip">
                        <span class="el-icon-success"></span>
                        <p>视频学习完毕，根据提示实操练习</p>
                        <p>
                            <a class="restart" @click="restartVideo"><i class="el-icon-refresh-left"></i>重播</a>
                            <a class="startstudy" @click="studyNext('#tab-first')">继续下一步学习</a>
                        </p>
                    </div>
                </div>
            </el-tab-pane>
			<!--第1步 登录千牛-->
			<el-tab-pane name="first">
				<div slot="label" class="tab-slot">
					<p class="title">1、登录千牛</p>
					<div class="hover-con">
						<p><i class="el-icon-video-play"></i></p>
						<p>点击学习</p>
					</div>
				</div>
				<div id="video-first" class="video-box">
					<video id="first" src="http://taojinyun.file.itaojin.cn/qianniusource/202412/step1.mp4"
						controls="controls" class="video">
						您的浏览器不支持 video 标签。
					</video>
					<div class="video-mask"></div>
				</div>
				<div id="stoptip-first" class="stoptip">
					<div class="tip">
						<span class="el-icon-success"></span>
						<p>视频学习完毕，根据提示实操练习</p>
						<p>
							<a class="restart" @click="restartVideo"><i class="el-icon-refresh-left"></i>重播</a>
							<a class="startstudy" @click="startStudy">开始实操练习</a>
						</p>
					</div>
				</div>
				<div id="content-first" class="content">
					<div class="con-left" style="padding: 0;">
						<!--双击图标-->
						<div v-show="isShowQnIcon || isShowLoginImg || isShowRnd" class="qnbox" style="user-select: none;">
							<img v-show="!mouseFocus" class="qnbg" :src="require('@/assets/images/newestqianniu/qnbg1.png')" />
							<img v-show="mouseFocus" class="qnbg" :src="require('@/assets/images/newestqianniu/qnbg2.png')" />
							<div class="qnicon01" @mouseenter="mouseFocus = true" @mouseleave="mouseFocus = false" @click="showLoginImg" />

							<!--登录-->
							<div v-show="isShowLoginImg" class="login" style="user-select: none;">
								<img v-show="isSaveAP" :src="require('@/assets/images/newestqianniu/login3.png')" class="homeImg">
								<img v-show="!isSaveAP && mouseFocusSaveAP" :src="require('@/assets/images/newestqianniu/login2.png')" class="homeImg">
								<img v-show="!isSaveAP && !mouseFocusSaveAP" :src="require('@/assets/images/newestqianniu/login1.png')" class="homeImg">
								<input type="text" v-model.trim="name" class="name" placeholder="请输入账号" />
								<input type="password" v-model.trim="password" autocomplete="new-password" class="password" placeholder="请输入密码" />
								<div class="hovertag" @mouseenter="mouseFocusSaveAP = true" @mouseleave="mouseFocusSaveAP = false" @click="isSaveAP = true"></div>
								<div class="logIn" @click="loginIn"></div>
							</div>
							<!--获取随机码-->
							<div v-show="isShowRnd" class="loginrnd">
								<img v-show="showRnd" :src="require('@/assets/images/newestqianniu/loginrnd3.png')" class="rndImg">
								<img v-show="!showRnd && mouseFocusRnd" :src="require('@/assets/images/newestqianniu/loginrnd2.png')" class="rndImg">
								<img v-show="!showRnd && !mouseFocusRnd" :src="require('@/assets/images/newestqianniu/loginrnd1.png')" class="rndImg">
								<div class="sendRnd" @mouseenter="mouseFocusRnd = true" @mouseleave="mouseFocusRnd = false" @click="showRnd = true"></div>
								<input type="text" @mouseenter="mouseFocusRnd = true" @mouseleave="mouseFocusRnd = false" v-model.trim="rnd" class="rnd" placeholder="短信验证码" />
								<div class="logInRnd" @click="loginInRnd"></div>
							</div>
						</div>
						<div v-show="isShowQnIcon2" class="qnbox">
							<img class="qnbg" :src="require('@/assets/images/newestqianniu/qnbg2.png')" />
							<div class="qnicon02" @dblclick="showLoginImg2" />
						</div>
						
						<!--登录成功点击会话图标-->
						<div v-show="isShowLoginIndex" class="jdbox">
							<img v-show="mouseFocusJD" class="jdimg" :src="require('@/assets/images/newestqianniu/loginindex1.png')" />
							<img v-show="!mouseFocusJD" class="jdimg"  :src="require('@/assets/images/newestqianniu/loginindex2.png')" />
							<div class="jdicon" @mouseenter="mouseFocusJD = true" @mouseleave="mouseFocusJD = false" @click="enterJd"></div>
						</div>
						<!--完成-->
						<div v-show="isShowLoginIndexTwo" class="indexbox">
							<img class="indeximg" :src="require('@/assets/images/newestqianniu/loginindex3.png')" />
						</div>
					</div>
					<div class="con-right">
						<h3>
							<span class="line"></span>
							提示
						</h3>
						<!--双击图标-->
						<p v-if="isShowQnIcon || isShowQnIcon2">请点击<span
								style="color: red;font-weight:bold;">左侧练习场</span>中的千牛图标进行登录</p>
						<!--登录-->
						<template v-if="isShowLoginImg">
							<p>1.复制粘贴账号和密码</p>
							<p>2.勾选记住密码</p>
							<el-button type="primary" @click="showPassword = true">获取账号密码</el-button>
							<template v-if="showPassword">
								<p><span style="color: red;font-weight:normal;">账号：淘金云客服:小淘</span></p>
								<p><span style="color: red;font-weight:normal;">密码：Tj1234</span></p>
							</template>
						</template>
						<!--获取随机码-->
						<template v-if="isShowRnd">
							<template v-if="showRnd">
								<p>短信验证码：</p>
								<p><span style="color: red;font-weight:bold;">660220</span></p>
							</template>
							<template v-else>
								<p><span style="color: red;font-weight:bold;">获取短信校验码</span></p>
							</template>
						</template>
						<!--进入接待中心-->
						<p v-if="isShowLoginIndex">请进入<span style="color: red;font-weight:bold;">接待中心</span></p>
					</div>
				</div>
				<div id="studytip-first" class="stoptip" style="height: 696px;">
					<div class="tip">
						<span class="el-icon-success"></span>
						<p>实操通关，进入下一关吧</p>
						<p>
							<a class="restart" @click="restartStudyFirst"><i class="el-icon-refresh-left"></i>重练</a>
							<a class="startstudy" @click="studyNext('#tab-second')">GO，下一关</a>
						</p>
					</div>
				</div>
				<div class="study-box">
					<h3>
						<span class="line"></span>
						查看学习资料
					</h3>
					<el-row>
						<el-col :span="20">
							<img class="img-box" :src="require('@/assets/images/newqianniu/ppt.png')"/>
							<div class="con-box">
								<p>千牛练习-登录千牛.ppt</p>
								<p>
									<a v-if="isOpenPpt" class="btn-open" @click="viewPpt(false)">点击收起</a>
									<a v-else class="btn-open" @click="viewPpt">点击展开</a>
								</p>
							</div>
						</el-col>
						<el-col :span="4">
							<el-button v-if="isShowBtn[tabCurrent]" type="primary" class="pull-right startbtn"
								@click="startStudy">开始练习</el-button>
						</el-col>
					</el-row>
					<div id="pdf_viewer"></div>
				</div>
			</el-tab-pane>
			<!--第2步 切换状态-->
			<el-tab-pane name="second">
				<div slot="label" class="tab-slot">
					<p class="title">2、基础设置（上）</p>
					<div class="hover-con">
						<p><i class="el-icon-video-play"></i></p>
						<p>点击学习</p>
					</div>
				</div>
				<div id="video-second" class="video-box">
					<video id="second" src="http://taojinyun.file.itaojin.cn/qianniusource/202412/step2.mp4"
						controls="controls" class="video">
						您的浏览器不支持 video 标签。
					</video>
					<div class="video-mask"></div>
				</div>
				<div id="stoptip-second" class="stoptip">
					<div class="tip">
						<span class="el-icon-success"></span>
						<p>视频学习完毕，根据提示实操练习</p>
						<p>
							<a class="restart" @click="restartVideo"><i class="el-icon-refresh-left"></i>重播</a>
							<a class="startstudy" @click="startStudy">开始实操练习</a>
						</p>
					</div>
				</div>
				<div id="content-second" class="content">
					<div class="con-left">
						<!--挂起-->
						<div v-show="secondStep == 1" class="gqbox">
							<img v-show="gqstep == 1" class="gqimg" :src="require('@/assets/images/newestqianniu/qnstatus1.png')" />
							<div v-show="gqstep == 1" class="gqbtn" @click="gqstep = 2">&nbsp;</div>
							<img v-show="gqstep == 2 && mouseFocusZX" class="gqimg" :src="require('@/assets/images/newestqianniu/qnstatus3.png')" />
							<img v-show="gqstep == 2 && !mouseFocusZX" class="gqimg" :src="require('@/assets/images/newestqianniu/qnstatus2.png')" />
							<div v-show="gqstep == 2" @mouseenter="mouseFocusZX = true" @mouseleave="mouseFocusZX = false" class="gqclick" @click="secondStep = 2">&nbsp;</div>
						</div>
						<!--未挂起-->
						<div v-show="secondStep == 2" class="wgqbox">
							<img v-show="wgqstep == 1" class="wgqimg" :src="require('@/assets/images/newestqianniu/qnstatus4.png')" />
							<div v-show="wgqstep == 1" class="gqbtn" @click="wgqstep = 2">&nbsp;</div>
							<img v-show="wgqstep == 2 && mouseFocusGQ" class="wgqimg" :src="require('@/assets/images/newestqianniu/qnstatus6.png')" />
							<img v-show="wgqstep == 2 && !mouseFocusGQ" class="wgqimg" :src="require('@/assets/images/newestqianniu/qnstatus5.png')" />
							<div v-show="wgqstep == 2" @mouseenter="mouseFocusGQ = true" @mouseleave="mouseFocusGQ = false" class="gqclick" @click="wgqstep = 3">&nbsp;</div>
							<img v-show="wgqstep == 3" class="wgqimg" :src="require('@/assets/images/newestqianniu/qnstatus7.png')" />
							<div v-show="wgqstep == 3" class="cgqbtn" @click="secondStep = 3">&nbsp;</div>
						</div>

						<div v-show="secondStep == 3" class="second-step3">
							<img v-show="secondStepStep == 1" class="img-base" :src="require('@/assets/images/newestqianniu/qnstatus1.png')" />
							<div v-show="secondStepStep == 1" class="btn1" @click="secondStepStep = 2"></div>
							<img v-show="secondStepStep == 2 && !mouseFocusDdsc" class="img-base" :src="require('@/assets/images/newestqianniu/qnsort1.png')" />
							<img v-show="secondStepStep == 2 && mouseFocusDdsc" class="img-base" :src="require('@/assets/images/newestqianniu/qnsort2.png')" />
							<div v-show="secondStepStep == 2" @mouseenter="mouseFocusDdsc = true" @mouseleave="mouseFocusDdsc = false" class="btn2" @click="secondStep = 4">&nbsp;</div>
						</div>
						<div v-show="secondStep == 4" class="second-step3">
							<img v-show="secondStepStep == 2 && !mouseFocusSet" class="img-base" :src="require('@/assets/images/newestqianniu/qnsort3.png')" />
							<img v-show="secondStepStep == 2 && mouseFocusSet" class="img-base" :src="require('@/assets/images/newestqianniu/qnset1.png')" />
							<div v-show="secondStepStep == 2" @mouseenter="mouseFocusSet = true" @mouseleave="mouseFocusSet = false" class="btn3" @click="secondStepStep = 3">&nbsp;</div>
							<img v-show="secondStepStep == 3 && !mouseFocusSetInfo" class="img-base" :src="require('@/assets/images/newestqianniu/qnset2.png')" />
							<img v-show="secondStepStep == 3 && mouseFocusSetInfo" class="img-base" :src="require('@/assets/images/newestqianniu/qnset3.png')" />
							<div v-show="secondStepStep == 3" @mouseenter="mouseFocusSetInfo = true" @mouseleave="mouseFocusSetInfo = false" class="btn4" @click="secondStepStep = 4">&nbsp;</div>
							<img style="height: 681.5px;" v-show="secondStepStep == 4 && !mouseFocusSetInfoDetail" class="img-base" :src="require('@/assets/images/newestqianniu/qnset4.png')" />
							<img style="height: 681.5px;" v-show="secondStepStep == 4 && mouseFocusSetInfoDetail" class="img-base" :src="require('@/assets/images/newestqianniu/qnset5.png')" />
							<div v-show="secondStepStep == 4" @mouseenter="mouseFocusSetInfoDetail = true" @mouseleave="mouseFocusSetInfoDetail = false" class="btn5" @click="showGqImgClick">&nbsp;</div>
							<img style="height: 681.5px;" v-show="secondStepStep == 5" class="img-base" :src="require('@/assets/images/newestqianniu/qnset6.png')" />
						</div>
					</div>
					<div class="con-right">
						<h3>
							<span class="line"></span>
							提示
						</h3>
						<p v-if="secondStep == 1">请将状态切换为<span class="red-span">在线</span>状态</p>
						<p v-else-if = "secondStep == 2">请将状态切换为<span class="red-span">挂起</span>状态</p>
						<p v-else-if = "secondStep == 3">请将接待排序设置为：<span class="red-span">按客户等待时长排序</span></p>
						<p v-else-if = "secondStep == 4">请进入<span class="red-span">系统设置</span>中的<span class="red-span">消息接收与提醒，</span>核对<span class="red-span">店铺分流</span>和<span class="red-span">账号分流</span>是否开启</p>
					</div>
				</div>
				<div id="studytip-second" class="stoptip">
					<div class="tip">
						<span class="el-icon-success"></span>
						<p>实操通关，进入下一关吧</p>
						<p>
							<a class="restart" @click="restartStudySecond"><i class="el-icon-refresh-left"></i>重练</a>
							<a class="startstudy" @click="studyNext('#tab-third')">GO，下一关</a>
						</p>
					</div>
				</div>
				<div class="study-box">
					<h3>
						<span class="line"></span>
						查看学习资料
					</h3>
					<el-row>
						<el-col :span="20">
							<img class="img-box" :src="require('@/assets/images/newqianniu/ppt.png')" />
							<div class="con-box">
								<p>千牛练习-基础设置（上）.ppt</p>
								<p>
									<a v-if="isOpenPpt2" class="btn-open" @click="viewPpt2(false)">点击收起</a>
									<a v-else class="btn-open" @click="viewPpt2">点击展开</a>
								</p>
							</div>
						</el-col>
						<el-col :span="4">
							<el-button v-if="isShowBtn[tabCurrent]" type="primary" class="pull-right startbtn"
								@click="startStudy">开始练习</el-button>
						</el-col>
					</el-row>
					<div id="pdf_viewer2"></div>
				</div>
			</el-tab-pane>
			<!--第3步 快捷短语-->
			<el-tab-pane name="third">
				<div slot="label" class="tab-slot">
					<p class="title">3、基础设置（下）</p>
					<div class="hover-con">
						<p><i class="el-icon-video-play"></i></p>
						<p>点击学习</p>
					</div>
				</div>
				<div id="video-third" class="video-box">
					<video id="third" src="http://taojinyun.file.itaojin.cn/qianniusource/202412/step3.mp4" controls="controls" class="video">
						您的浏览器不支持 video 标签。
					</video>
					<div class="video-mask"></div>
				</div>
				<div id="stoptip-third" class="stoptip">
					<div class="tip">
						<span class="el-icon-success"></span>
						<p>视频学习完毕，根据提示实操练习</p>
						<p>
							<a class="restart" @click="restartVideo"><i class="el-icon-refresh-left"></i>重播</a>
							<a class="startstudy" @click="startStudy">开始实操练习</a>
						</p>
					</div>
				</div>
				<div id="content-third" class="content">
					<div class="con-left">
						<!--接待顾客-->
						<div class="jdgkbox">
							<img v-show="kjdyStep == 1" class="img-base" :src="require('@/assets/images/newestqianniu/kjdy1.png')" />
							<div v-show="kjdyStep == 1" class="search-c">
								<el-input class="search" v-model="kjdySearch" @input="kjdySearchChange" placeholder="联系人,订单号，聊天记录"></el-input>
							</div>
							<img v-show="kjdyStep == 2" class="img-base" :src="require('@/assets/images/newestqianniu/kjdy2.png')" />
							<div v-show="kjdyStep == 2" class="btn2" @click="kjdyStep = 3">&nbsp;</div>
							<img v-show="kjdyStep == 3 && !mouseFocusKJDY" class="img-base" :src="require('@/assets/images/newestqianniu/kjdy3.png')" />
							<img v-show="kjdyStep == 3 && mouseFocusKJDY" class="img-base" :src="require('@/assets/images/newestqianniu/kjdy4.png')" />
							<div v-show="kjdyStep == 3" class="btn3" @mouseenter="mouseFocusKJDY= true" @mouseleave="mouseFocusKJDY = false" @click="kjdyStep = 4">&nbsp;</div>
							<img v-show="kjdyStep == 4" class="img-base" :src="require('@/assets/images/newestqianniu/kjdy5.png')" />
							<div v-show="kjdyStep == 4" class="btn4" @click="kjdyStep = 5">&nbsp;</div>
							<!-- 快捷短语弹出 -->
							<img v-if="kjdyStep == 5" class="img-base" :src="require('@/assets/images/newestqianniu/kjdy6.png')" />

							<div v-show="kjdyStep == 5" class="btn5" @click="kjdyStep = 6">&nbsp;</div>
							<img v-show="kjdyStep == 6 && !mouseFocusFZ" class="img-base" :src="require('@/assets/images/newestqianniu/kjdy7.png')" />
							<img v-show="kjdyStep == 6 && mouseFocusFZ" class="img-base" :src="require('@/assets/images/newestqianniu/kjdy8.png')" />
							<div v-show="kjdyStep == 6" class="btn6" @mouseenter="mouseFocusFZ= true" @mouseleave="mouseFocusFZ = false" @click="kjdyStep = 7">&nbsp;</div>
							<img v-show="kjdyStep == 7 && !mouseFocusFZI" class="img-base" :src="require('@/assets/images/newestqianniu/kjdy9.png')" />
							<img v-show="kjdyStep == 7 && mouseFocusFZI" class="img-base" :src="require('@/assets/images/newestqianniu/kjdy10.png')" />
							<div class="kjdyfz-c" v-show="kjdyStep == 7" @mouseenter="mouseFocusFZI= true" @mouseleave="mouseFocusFZI = false">
								<el-input placeholder="请输入分组" class="kjfz-input" v-model="kjdyfz"></el-input>
							</div>
							<div v-show="kjdyStep == 7" class="btn7" @click="kjdyfzConfirm"></div>
							<img v-show="kjdyStep == 8" class="img-base" :src="require('@/assets/images/newestqianniu/kjdy11.png')" />
							<div class="kjbm-c" v-show="kjdyStep == 5 || kjdyStep == 6 || kjdyStep == 8">
								<el-input class="kjbm-input" v-model="kjdybm"></el-input>
							</div>
							<div class="kjdy-c" v-show="kjdyStep == 5 || kjdyStep == 6 || kjdyStep == 8">
								<el-input placeholder="请输入快捷短语" type="textarea" class="kjdy-input" v-model="kjdynr"></el-input>
							</div>
							<div v-show="kjdyStep == 8" class="btn8" @click="kjdyConfirm">&nbsp;</div>
							<img v-show="kjdyStep == 9" class="img-base" :src="require('@/assets/images/newestqianniu/kjdy12.png')" />
							<div v-show="kjdyStep == 9" class="btn9" @click="kjdyStep = 10">&nbsp;</div>
							<img v-show="kjdyStep == 10" class="img-base" :src="require('@/assets/images/newestqianniu/kjdy13.png')" />
							<input ref="fileInput" type="file" @change="tirggerFile($event)" class="btn-file" />
							<img v-show="kjdyStep == 11" class="img-base" :src="require('@/assets/images/newestqianniu/kjdy14.png')" />
							<div v-show="kjdyStep == 11" class="btn11" @click="kjdyStep = 12">&nbsp;</div>
							<img v-show="kjdyStep == 12 && !mouseFocusKJDY" class="img-base" :src="require('@/assets/images/newestqianniu/kjdy15.png')" />
							<img v-show="kjdyStep == 12 && mouseFocusKJDY" class="img-base" :src="require('@/assets/images/newestqianniu/kjdy16.png')" />
							<div v-show="kjdyStep == 12" @mouseenter="mouseFocusKJDY= true" @mouseleave="mouseFocusKJDY = false" class="btn12" @click="kjdyStep = 13">&nbsp;</div>
							<img v-show="kjdyStep == 13" class="img-base" :src="require('@/assets/images/newestqianniu/kjdy17.png')" />
							<input v-if="kjdyStep == 13" type="text" class="btn133" v-focus="true" @keyup.enter="kjdyStep = 14"/>
							<div v-show="kjdyStep == 13" class="btn13" @click="kjdyStep = 14">&nbsp;</div>
							<img v-show="kjdyStep == 14" class="img-base" :src="require('@/assets/images/newestqianniu/kjdy18.png')" />
							<div class="kjdyfs-c" v-show="kjdyStep == 14">
								<el-input class="kjdyfs-input" type="textarea" v-model="kjdyfs" @input="kjdyfsChange"></el-input>
							</div>
							<img v-show="kjdyStep == 15" class="img-base" :src="require('@/assets/images/newestqianniu/kjdy19.png')" />
							<input v-if="kjdyStep == 15" type="text" class="btn155" v-focus="true" @keyup.enter="enterSelect"/>
							<div v-show="kjdyStep == 15" class="btn15" @click="enterSelect">&nbsp;</div>
							<img v-show="kjdyStep == 16" class="img-base" :src="require('@/assets/images/newestqianniu/kjdy20.png')" />
							<input v-if="kjdyStep == 16" ref="sixInput" type="text" class="btn16" v-focus="true" @keyup.enter="finishThird"/>
							<div v-show="kjdyStep == 16" class="btn13" @click="finishThird">&nbsp;</div>
							<img v-show="kjdyStep == 17" class="img-base" :src="require('@/assets/images/newestqianniu/kjdy21.png')" />
						</div>
					</div>
					<div class="con-right">
						<h3>
							<span class="line"></span>
							提示
						</h3>
						<p v-if="kjdyStep == 1 || kjdyStep == 2">请搜索登录账号<br><span style="color: red;font-weight:bold;">淘金云客服:小淘</span></p>
						<p v-if="kjdyStep == 3">请<span style="color: red;font-weight:bold;">打开快捷短语</span></p>
						<template v-if="kjdyStep == 4 || kjdyStep == 5 || kjdyStep == 6 || kjdyStep == 7 || kjdyStep == 8">
							<p>请<span style="color: red;font-weight:bold;">新增一条</span>快捷短语。短语内容：<span style="color: red;font-weight:bold;">亲，欢迎光临，请问有什么可以帮您的？</span></p>
							<p>快捷编码：<span style="color: red;font-weight:bold;">欢迎</span></p>
							<p>分组：<span style="color: red;font-weight:bold;">开头语</span>（需要自己新增分组）</p>
						</template>
						<template v-if="kjdyStep == 9 || kjdyStep == 10 || kjdyStep == 11">
							<p>请<span class="red-span">先下载</span>快捷短语表格<span class="red-span">并保存到桌面上</span>，再<span class="red-span">导入</span>快捷短语。</p>
							<p><a @click="downloadKjdyFile">点击下载"快捷短语.csv"</a></p>
						</template>
						<template v-if="kjdyStep == 12 || kjdyStep == 13">
							<p>请采用<span class="red-span">鼠标左键</span>点击快捷短语的方式，选择<span class="red-span">并发送</span>快捷短语：<span class="red-span">亲，欢迎光临，请问有什么可以帮您的？</span></p>
						</template>
						<template v-if="kjdyStep == 14 || kjdyStep == 15 || kjdyStep == 16 || kjdyStep == 17">
							<p>请采用<span class="red-span">/+快捷编码</span>点击快捷短语的方式，选择<span class="red-span">并发送</span>快捷短语：<span class="red-span">亲，欢迎光临，请问有什么可以帮您的？</span></p>
						</template>

					</div>
				</div>
				<div id="studytip-third" class="stoptip">
					<div class="tip">
						<span class="el-icon-success"></span>
						<p>实操通关，进入下一关吧</p>
						<p>
							<a class="restart" @click="restartStudyThird"><i class="el-icon-refresh-left"></i>重练</a>
							<a class="startstudy" @click="studyNext('#tab-four')">GO，下一关</a>
						</p>
					</div>
				</div>
				<div class="study-box">
					<h3>
						<span class="line"></span>
						查看学习资料
					</h3>
					<el-row>
						<el-col :span="20">
							<img class="img-box" :src="require('@/assets/images/newqianniu/ppt.png')"/>
							<div class="con-box">
								<p>千牛练习-设置快捷短语.ppt</p>
								<p>
									<a v-if="isOpenPpt3" class="btn-open" @click="viewPpt3(false)">点击收起</a>
									<a v-else class="btn-open" @click="viewPpt3">点击展开</a>
								</p>
							</div>
						</el-col>
						<el-col :span="4">
							<el-button v-if="isShowBtn[tabCurrent]" type="primary" class="pull-right startbtn"
								@click="startStudy">开始练习</el-button>
						</el-col>
					</el-row>
					<div id="pdf_viewer3"></div>
				</div>
			</el-tab-pane>
			<!--第4步 会话窗口常用功能-->
			<el-tab-pane name="four">
				<div slot="label" class="tab-slot">
					<p class="title">4、会话窗口常用功能</p>
					<div class="hover-con">
						<p><i class="el-icon-video-play"></i></p>
						<p>点击学习</p>
					</div>
				</div>
				<div id="video-four" class="video-box">
					<video id="four" src="http://taojinyun.file.itaojin.cn/qianniusource/202412/step4.mp4"
						controls="controls" class="video">
						您的浏览器不支持 video 标签。
					</video>
					<div class="video-mask"></div>
				</div>
				<div id="stoptip-four" class="stoptip">
					<div class="tip">
						<span class="el-icon-success"></span>
						<p>视频学习完毕，根据提示实操练习</p>
						<p>
							<a class="restart" @click="restartVideo"><i class="el-icon-refresh-left"></i>重播</a>
							<a class="startstudy" @click="startStudy">开始实操练习</a>
						</p>
					</div>
				</div>
				<div id="content-four" class="content">
					<div class="con-left">
						<div class="cygnbox">
							<img v-show="cygnStep == 1" class="img-base" :src="require('@/assets/images/newestqianniu/cygn1.png')" />
							<div v-show="cygnStep == 1" class="btn1"  @mouseenter="cygnStep = 2">&nbsp;</div>
							<img v-show="cygnStep == 2 && !mouseFocusDdsc" class="img-base" :src="require('@/assets/images/newestqianniu/cygn2.png')" />
							<img v-show="cygnStep == 2 && mouseFocusDdsc" class="img-base" :src="require('@/assets/images/newestqianniu/cygn3.png')" />
							<div v-show="cygnStep == 2" class="btn2"  @mouseenter="mouseFocusDdsc = true" @mouseleave="mouseFocusDdsc = false" @click="fourStepBystep">&nbsp;</div>
							<img v-show="cygnStep == 3" class="img-base" :src="require('@/assets/images/newestqianniu/cygn4.png')" />
							<img v-show="cygnStep == 4 && !mouseFocus" class="img-base" :src="require('@/assets/images/newestqianniu/cygn5.png')" />
							<img v-show="cygnStep == 4 && mouseFocus" class="img-base" :src="require('@/assets/images/newestqianniu/cygn6.png')" />
							<div v-show="cygnStep == 4" class="btn3"  @mouseenter="mouseFocus = true" @mouseleave="mouseFocus = false" @click="cygnStep = 5">&nbsp;</div>
							<img v-show="cygnStep == 5" class="img-base" :src="require('@/assets/images/newestqianniu/cygn7.png')" />
							<div v-show="cygnStep == 5" class="btn5"  @click="cygnStep = 6">&nbsp;</div>
							<img v-show="cygnStep == 6" class="img-base" :src="require('@/assets/images/newestqianniu/cygn8.png')" />
							<div class="zfyy-c" v-show="cygnStep == 6">
								<el-input placeholder="请输入转交原因" class="zjyy-input" v-model="zjyy"></el-input>
							</div>
							<div v-show="cygnStep == 6" class="btn6"  @click="sendZfyy">&nbsp;</div>
							<img v-show="cygnStep == 7" class="img-base" :src="require('@/assets/images/newestqianniu/cygn10.png')" />
						</div>
					</div>
					<div class="con-right">
						<h3>
							<span class="line"></span>
							提示
						</h3>
						<p v-if="cygnStep == 1 || cygnStep == 2 || cygnStep == 3">请给当前用户标记<span class="red-span">黄色星星</span></p>
						<p v-if="cygnStep == 4 || cygnStep == 5 || cygnStep == 6 || cygnStep == 7">请将当前用户<span class="red-span">转发</span>给<span class="red-span">小金</span>，转交原因填写<span class="red-span">少件</span></p>
					</div>
				</div>
				<div id="studytip-four" class="stoptip">
					<div class="tip">
						<span class="el-icon-success"></span>
						<p>实操通关，进入下一关吧</p>
						<p>
							<a class="restart" @click="restartStudyFour"><i class="el-icon-refresh-left"></i>重练</a>
							<a class="startstudy" @click="studyNext('#tab-five')">GO，下一关</a>
						</p>
					</div>
				</div>
				<div class="study-box">
					<h3>
						<span class="line"></span>
						查看学习资料
					</h3>
					<el-row>
						<el-col :span="20">
							<img class="img-box" :src="require('@/assets/images/newqianniu/ppt.png')"/>
							<div class="con-box">
								<p>千牛练习-会话窗口常用功能.ppt</p>
								<p>
									<a v-if="isOpenPpt4" class="btn-open" @click="viewPpt4(false)">点击收起</a>
									<a v-else class="btn-open" @click="viewPpt4">点击展开</a>
								</p>
							</div>
						</el-col>
						<el-col :span="4">
							<el-button v-if="isShowBtn[tabCurrent]" type="primary" class="pull-right startbtn"
								@click="startStudy">开始练习</el-button>
						</el-col>
					</el-row>
					<div id="pdf_viewer4"></div>
				</div>
			</el-tab-pane>
			<!--第5步 智能客服插件(上)-->
			<el-tab-pane name="five">
				<div slot="label" class="tab-slot">
					<p class="title">5、智能客服插件(上)</p>
					<div class="hover-con">
						<p><i class="el-icon-video-play"></i></p>
						<p>点击学习</p>
					</div>
				</div>
				<div id="video-five" class="video-box">
					<video id="five" src="http://taojinyun.file.itaojin.cn/qianniusource/202412/step5.mp4"
						controls="controls" class="video">
						您的浏览器不支持 video 标签。
					</video>
					<div class="video-mask"></div>
				</div>
				<div id="stoptip-five" class="stoptip">
					<div class="tip">
						<span class="el-icon-success"></span>
						<p>视频学习完毕，根据提示实操练习</p>
						<p>
							<a class="restart" @click="restartVideo"><i class="el-icon-refresh-left"></i>重播</a>
							<a class="startstudy" @click="startStudy">开始实操练习</a>
						</p>
					</div>
				</div>
				<div id="content-five" class="content">
					<div class="con-left">
						<div class="zncj-top-box">
							<img v-show="zncjsstep == 1 && !mouseFocus" class="img-base" :src="require('@/assets/images/newestqianniu/tjsp1.png')" />
							<img v-show="zncjsstep == 1 && mouseFocus" class="img-base" :src="require('@/assets/images/newestqianniu/tjsp2.png')" />
							<div v-show="zncjsstep == 1" class="btn1"  @mouseenter="mouseFocus = true" @mouseleave="mouseFocus = false" @click="zncjsstep = 2">&nbsp;</div>
							<img v-show="zncjsstep == 2 && !mouseFocus" class="img-base" :src="require('@/assets/images/newestqianniu/tjsp3.png')" />
							<img v-show="zncjsstep == 2 && mouseFocus" class="img-base" :src="require('@/assets/images/newestqianniu/tjsp4.png')" />
							<div v-show="zncjsstep == 2" class="btn2"  @mouseenter="mouseFocus = true" @mouseleave="mouseFocus = false" @click="tjspEnd">&nbsp;</div>
							<img v-show="zncjsstep == 3" class="img-base" :src="require('@/assets/images/newestqianniu/tjsp5.png')" />
						</div>
					</div>
					<div class="con-right">
						<h3>
							<span class="line"></span>
							提示
						</h3>
						<p v-if="zncjsstep == 1 || zncjsstep == 2 || zncjsstep == 3">请将<span class="red-span">商品导购区</span>客户<span class="red-span">足迹</span>中<span class="red-span">符合客户需求</span>的商品发送给客户</p>
					</div>
				</div>
				<div id="studytip-five" class="stoptip">
					<div class="tip">
						<span class="el-icon-success"></span>
						<p>实操通关，进入下一关吧</p>
						<p>
							<a class="restart" @click="restartStudyFive"><i class="el-icon-refresh-left"></i>重练</a>
							<a class="startstudy" @click="studyNext('#tab-six')">GO，下一关</a>
						</p>
					</div>
				</div>
				<div class="study-box">
					<h3>
						<span class="line"></span>
						查看学习资料
					</h3>
					<el-row>
						<el-col :span="20">
							<img class="img-box" :src="require('@/assets/images/newqianniu/ppt.png')"/>
							<div class="con-box">
								<p>千牛练习-智能客服插件(上).ppt</p>
								<p>
									<a v-if="isOpenPpt5" class="btn-open" @click="viewPpt5(false)">点击收起</a>
									<a v-else class="btn-open" @click="viewPpt5">点击展开</a>
								</p>
							</div>
						</el-col>
						<el-col :span="4">
							<el-button v-if="isShowBtn[tabCurrent]" type="primary" class="pull-right startbtn"
								@click="startStudy">开始练习</el-button>
						</el-col>
					</el-row>
					<div id="pdf_viewer5"></div>
				</div>
			</el-tab-pane>
			<!--第6步 智能客服插件(下)-->
			<el-tab-pane name="six">
				<div slot="label" class="tab-slot">
					<p class="title">6、智能客服插件(下)</p>
					<div class="hover-con">
						<p><i class="el-icon-video-play"></i></p>
						<p>点击学习</p>
					</div>
				</div>
				<div id="video-six" class="video-box">
					<video id="six" src="http://taojinyun.file.itaojin.cn/qianniusource/202412/step6.mp4"
						controls="controls" class="video">
						您的浏览器不支持 video 标签。
					</video>
					<div class="video-mask"></div>
				</div>
				<div id="stoptip-six" class="stoptip">
					<div class="tip">
						<span class="el-icon-success"></span>
						<p>视频学习完毕，根据提示实操练习</p>
						<p>
							<a class="restart" @click="restartVideo"><i class="el-icon-refresh-left"></i>重播</a>
							<a class="startstudy" @click="startStudy">开始实操练习</a>
						</p>
					</div>
				</div>
				<div id="content-six" class="content">
					<div class="con-left">
						<div class="zncj-bottom-box">
							<img v-show="zncjxstep == 1" class="img-base" :src="require('@/assets/images/newestqianniu/fkzt1.png')" />
							<div v-show="zncjxstep == 1" class="btn1" @click="zncjxstep = 2">&nbsp;</div>
							<img v-show="zncjxstep == 2" class="img-base" :src="require('@/assets/images/newestqianniu/fkzt2.png')" />
							<div v-show="zncjxstep == 2" class="btn2" @click="zncjxstep = 3">&nbsp;</div>
							<img v-show="zncjxstep == 3" class="img-base" :src="require('@/assets/images/newestqianniu/fkzt3.png')" />
							<div v-show="zncjxstep == 3" class="btn3" @click="sixStepByStep">&nbsp;</div>
							<img v-show="zncjxstep == 4" class="img-base" :src="require('@/assets/images/newestqianniu/fkzt4.png')" />
							<img v-show="zncjxstep == 5" class="img-base" :src="require('@/assets/images/newestqianniu/ck1.png')" />
							<div v-show="zncjxstep == 5" class="btn6" @click="sixStepByStep2">&nbsp;</div>
							<img v-show="zncjxstep == 6" class="img-base" :src="require('@/assets/images/newestqianniu/ck2.png')" />
							<img v-show="zncjxstep == 7" class="img-base" :src="require('@/assets/images/newestqianniu/xgyf1.png')" />
							<div v-show="zncjxstep == 7" class="btn7" @click="showYfstep = true">&nbsp;</div>
							<img v-show="zncjxstep == 7 && showYfstep && !mouseFocus" class="img-yf" :src="require('@/assets/images/newestqianniu/yfalert1.png')" />
							<img v-show="zncjxstep == 7 && showYfstep && mouseFocus" class="img-yf" :src="require('@/assets/images/newestqianniu/yfalert2.png')" />
							<div v-show="zncjxstep == 7 && showYfstep" :class="{'yf-c': !mouseFocus,'yf-c1': mouseFocus}" @mouseenter="mouseFocus = true" @mouseleave="mouseFocus=false">
								<el-input placeholder="请输入邮费" class="yf-input" v-model="yfamount"></el-input>
							</div>
							<div v-show="zncjxstep == 7 && showYfstep" class="btn77" @click="sixStepByStep3">&nbsp;</div>
							<img v-show="zncjxstep == 8" class="img-base" :src="require('@/assets/images/newestqianniu/xgyf2.png')" />
							<div v-show="zncjxstep == 8" class="btn8" @click="zncjxstep = 9">&nbsp;</div>
							<img v-show="zncjxstep == 9" class="img-base" :src="require('@/assets/images/newestqianniu/bz1.png')" />
							<div v-show="zncjxstep == 9" class="btn9" @click="zncjxstep = 10">&nbsp;</div>
							<img v-show="zncjxstep == 10" class="img-base" :src="require('@/assets/images/newestqianniu/bz2.png')" />
							<div class="kjdy-c" v-show="zncjxstep == 10 || zncjxstep == 9">
								<el-input placeholder="请输入备注内容" type="textarea" class="kjdy-input" v-model="bznr"></el-input>
							</div>
							<div v-show="zncjxstep == 10" class="btn10" @click="sixStepByStep4">&nbsp;</div>
							<img v-show="zncjxstep == 11" class="img-base" :src="require('@/assets/images/newestqianniu/bz3.png')" />
							<img v-show="zncjxstep == 12" class="img-base" :src="require('@/assets/images/newestqianniu/hddd1.png')" />
							<div v-show="zncjxstep == 12" class="btn12" @click="sixStepByStep5">&nbsp;</div>
							<img v-show="zncjxstep == 13" class="img-base" :src="require('@/assets/images/newestqianniu/hddd2.png')" />
							<img v-show="zncjxstep == 14" class="img-base" :src="require('@/assets/images/newestqianniu/xgdh1.png')" />
							<div v-show="zncjxstep == 14" class="btn14" @click="zncjxstep = 15">&nbsp;</div>
							<img v-show="zncjxstep == 15" class="img-base" :src="require('@/assets/images/newestqianniu/xgdh2.png')" />
							<div class="phone" v-show="zncjxstep == 15">13656565656</div>
							<div v-show="zncjxstep == 15" class="phone-c" @mouseenter="mouseFocus = true" @mouseleave="mouseFocus=false">
								<el-input placeholder="请输入" class="phone-input" v-model="phone"></el-input>
							</div>
							<div v-show="zncjxstep == 15" class="btn15" @click="sixStepByStep6">&nbsp;</div>
							<img v-show="zncjxstep == 16" class="img-base" :src="require('@/assets/images/newestqianniu/xgdh1.png')" />
						</div>
					</div>
					<div class="con-right">
						<h3>
							<span class="line"></span>
							提示
						</h3>
						<p v-if="zncjxstep == 1">请将会话切换到<span class="red-span">未付款客户</span></p>
						<p v-if="zncjxstep == 2">请将会话切换到<span class="red-span">已付款</span>待发货<span class="red-span">客户</span></p>
						<p v-if="zncjxstep == 3 || zncjxstep == 4">请将会话切换到<span class="red-span">已发货</span>待收货<span class="red-span">客户</span></p>
						<p v-if="zncjxstep == 5 || zncjxstep == 6">请点击<span class="red-span">订单操作区</span>中的<span class="red-span">催付</span>按钮，给客户发送催付卡片</p>
						<p v-if="zncjxstep == 7">请<span class="red-span">根据聊天内容</span>在<span class="red-span">订单操作区</span>的<span class="red-span">改价</span>中<span class="red-span">修改邮费</span></p>
						<p v-if="zncjxstep == 8 || zncjxstep == 9 || zncjxstep == 10 || zncjxstep == 11">【假设商家要求<span class="red-span">发顺丰</span>的客户插<span class="red-span">红色</span>旗子】请<span class="red-span">添加订单备注，并勾选对应的彩旗。</span><br>备注内容为：发顺丰</p>
						<p v-if="zncjxstep ==12 || zncjxstep == 13">请点击<span class="red-span">订单操作区</span>中的<span class="red-span">核对订单</span>按钮，给客户发送订单卡片</p>
						<p v-if="zncjxstep ==14 || zncjxstep == 15 || zncjxstep == 16">请点击<span class="red-span">订单操作区</span>中的<span class="red-span">改址</span>按钮，修改客户电话</p>

					</div>
				</div>
				<div id="studytip-six" class="stoptip">
					<div class="tip">
						<span class="el-icon-success"></span>
						<p>实操通关，进入下一关吧</p>
						<p>
							<a class="restart" @click="restartStudySix"><i class="el-icon-refresh-left"></i>重练</a>
							<a class="startstudy" @click="studyNext('#tab-six1')">GO，下一关</a>
						</p>
					</div>
				</div>
				<div class="study-box">
					<h3>
						<span class="line"></span>
						查看学习资料
					</h3>
					<el-row>
						<el-col :span="20">
							<img class="img-box" :src="require('@/assets/images/newqianniu/ppt.png')"/>
							<div class="con-box">
								<p>千牛练习-智能客服插件(下).ppt</p>
								<p>
									<a v-if="isOpenPpt6" class="btn-open" @click="viewPpt6(false)">点击收起</a>
									<a v-else class="btn-open" @click="viewPpt6">点击展开</a>
								</p>
							</div>
						</el-col>
						<el-col :span="4">
							<el-button v-if="isShowBtn[tabCurrent]" type="primary" class="pull-right startbtn"
								>开始练习</el-button>
						</el-col>
					</el-row>
					<div id="pdf_viewer6"></div>
				</div>
			</el-tab-pane>
            <!--第6-1步 其他插件-->
			<el-tab-pane name="six1">
				<div slot="label" class="tab-slot">
					<p class="title">7、添加其他插件</p>
					<div class="hover-con">
						<p><i class="el-icon-video-play"></i></p>
						<p>点击学习</p>
					</div>
				</div>
				<div id="video-six1" class="video-box">
					<video id="six1" src="http://taojinyun.file.itaojin.cn/qianniusource/202412/step61.mp4"
						controls="controls" class="video">
						您的浏览器不支持 video 标签。
					</video>
					<div class="video-mask"></div>
				</div>
				<div id="stoptip-six1" class="stoptip">
					<div class="tip">
						<span class="el-icon-success"></span>
						<p>视频学习完毕，根据提示实操练习</p>
						<p>
							<a class="restart" @click="restartVideo"><i class="el-icon-refresh-left"></i>重播</a>
							<a class="startstudy" @click="startStudy">开始实操练习</a>
						</p>
					</div>
				</div>
				<div id="content-six1" class="content">
					<div class="con-left">
						<div class="qtcj-box">
							<img v-show="qtcjStep == 1" class="img-base" :src="require('@/assets/images/newestqianniu/qtcj01.png')" />
                            <img v-show="qtcjStep == 2" class="img-base" :src="require('@/assets/images/newestqianniu/qtcj02.png')" />
                            <div v-show="qtcjStep == 1 || qtcjStep == 2" class="gfkf-c">
								<el-input placeholder="联系人、订单号、聊天记录" class="gfkf-input" v-model="gfkf" @input="onGfkfInput"></el-input>
							</div>
                            <div v-show="qtcjStep == 2" class="gfkf-btn" @click="qtcjStep = 3">&nbsp;</div>
                            <img v-show="qtcjStep == 3" class="img-base" :src="require('@/assets/images/newestqianniu/qtcj03.png')" />
                            <div v-show="qtcjStep == 3" class="cjzx-btn" @click="qtcjStep = 4">&nbsp;</div>
                            <img v-show="qtcjStep == 4" class="img-base" :src="require('@/assets/images/newestqianniu/qtcj04.png')" />
                            <div v-show="qtcjStep == 4" class="fbtzj-btn" @click="qtcjStep = 5">&nbsp;</div>
                            <img v-show="qtcjStep == 5" class="img-base" :src="require('@/assets/images/newestqianniu/qtcj05.png')" />
                            <div v-show="qtcjStep == 5" class="lzykf-btn" @click="qtcjStep = 6">&nbsp;</div>
                            <img v-show="qtcjStep == 6" class="img-base" :src="require('@/assets/images/newestqianniu/qtcj06.png')" />
                            <div v-show="qtcjStep == 6" class="closecjzx-btn" @click="qtcjStep = 7">&nbsp;</div>
                            <img v-show="qtcjStep == 7" class="img-base" :src="require('@/assets/images/newestqianniu/qtcj07.png')" />
                            <div v-show="qtcjStep == 7" class="fbt-btn" @click="qtcjStep = 8">&nbsp;</div>
                            <img v-show="qtcjStep == 8" class="img-base" :src="require('@/assets/images/newestqianniu/qtcj08.png')" />
                            <div v-show="qtcjStep == 8" class="ly-btn" @click="six1StepEnd">&nbsp;</div>
						</div>
					</div>
					<div class="con-right">
						<h3>
							<span class="line"></span>
							提示
						</h3>
						<p v-if="qtcjStep == 1 || qtcjStep == 2">请搜索<span class="red-span">天猫官方客服</span></p>
                        <p v-if="qtcjStep == 3">请<span class="red-span">打开插件中心</span></p>
                        <p v-if="qtcjStep == 4">请添加<span class="red-span">FBT咨询</span>插件</p>
                        <p v-if="qtcjStep == 5">请添加<span class="red-span">瓴羊客服</span>插件</p>
                        <p v-if="qtcjStep == 6">请<span class="red-span">关闭插件中心</span></p>
                        <p v-if="qtcjStep == 7">此页面右侧是<span class="red-span">FBT插件</span>功能区。<br>请点击<span class="red-span">订单备注</span>按钮</p>
                        <p v-if="qtcjStep == 8">此页面右侧是<span class="red-span">瓴羊插件</span>功能区。<br>请点击<span class="red-span">物流详情</span>按钮</p>

					</div>
				</div>
				<div id="studytip-six1" class="stoptip">
					<div class="tip">
						<span class="el-icon-success"></span>
						<p>实操通关，进入下一关吧</p>
						<p>
							<a class="restart" @click="restartStudySix1"><i class="el-icon-refresh-left"></i>重练</a>
							<a class="startstudy" @click="studyNext('#tab-seven')">GO，下一关</a>
						</p>
					</div>
				</div>
				<div class="study-box">
					<h3>
						<span class="line"></span>
						查看学习资料
					</h3>
					<el-row>
						<el-col :span="20">
							<img class="img-box" :src="require('@/assets/images/newqianniu/ppt.png')"/>
							<div class="con-box">
								<p>千牛练习-其他插件.ppt</p>
								<p>
									<a v-if="isOpenPpt6" class="btn-open" @click="viewPpt61(false)">点击收起</a>
									<a v-else class="btn-open" @click="viewPpt61">点击展开</a>
								</p>
							</div>
						</el-col>
						<el-col :span="4">
							<el-button v-if="isShowBtn[tabCurrent]" type="primary" class="pull-right startbtn"
								>开始练习</el-button>
						</el-col>
					</el-row>
					<div id="pdf_viewer61"></div>
				</div>
			</el-tab-pane>
			<!--第7步 售后客服常用功能-->
			<el-tab-pane name="seven">
				<div slot="label" class="tab-slot">
					<p class="title">8、售后客服常用功能</p>
					<div class="hover-con">
						<p><i class="el-icon-video-play"></i></p>
						<p>点击学习</p>
					</div>
				</div>
				<div id="video-seven" class="video-box">
					<video id="seven" src="http://taojinyun.file.itaojin.cn/qianniusource/202412/step7.mp4"
						controls="controls" class="video">
						您的浏览器不支持 video 标签。
					</video>
					<div class="video-mask"></div>
				</div>
				<div id="stoptip-seven" class="stoptip">
					<div class="tip">
						<span class="el-icon-success"></span>
						<p>视频学习完毕，根据提示实操练习</p>
						<p>
							<a class="restart" @click="restartVideo"><i class="el-icon-refresh-left"></i>重播</a>
							<a class="startstudy" @click="startStudy">开始实操练习</a>
						</p>
					</div>
				</div>
				<div id="content-seven" class="content">
					<div class="con-left">
						<div class="sh-cygn">
							<img v-show="shcygnStep == 1 && !mouseFocusDdsc" class="img-base" :src="require('@/assets/images/newestqianniu/shcygn1.png')" />
							<img v-show="shcygnStep == 1 && mouseFocusDdsc" class="img-base" :src="require('@/assets/images/newestqianniu/shcygn2.png')" />
							<div v-show="shcygnStep == 1" class="btn1"  @mouseenter="mouseFocusDdsc = true" @mouseleave="mouseFocusDdsc = false" @click="shcygnStep = 2">&nbsp;</div>
							<img style="height: 681.5px;" v-show="shcygnStep == 2" class="img-base" :src="require('@/assets/images/newestqianniu/shcygn3.png')" />
							<div v-show="shcygnStep == 2" class="btn2"  @mouseenter="shcygnStep = 3">&nbsp;</div>
							<img style="height: 681.5px;" v-show="shcygnStep == 3 && !mouseFocus" class="img-base" :src="require('@/assets/images/newestqianniu/shcygn4.png')" />
							<img style="height: 681.5px;" v-show="shcygnStep == 3 && mouseFocus" class="img-base" :src="require('@/assets/images/newestqianniu/shcygn5.png')" />
							<div v-show="shcygnStep == 3" class="btn3"  @mouseenter="mouseFocus = true" @mouseleave="mouseFocus = false" @click="shcygnStep = 4">&nbsp;</div>
							<img style="height: 681.5px;" v-show="shcygnStep == 4 && !mouseFocusFZ" class="img-base" :src="require('@/assets/images/newestqianniu/shcygn6.png')" />
							<img style="height: 681.5px;" v-show="shcygnStep == 4 && mouseFocusFZ" class="img-base" :src="require('@/assets/images/newestqianniu/shcygn7.png')" />
							<div v-show="shcygnStep == 4" class="btn4"  @mouseenter="mouseFocusFZ = true" @mouseleave="mouseFocusFZ = false" @click="shcygnStep = 5">&nbsp;</div>
							<img style="height: 681.5px;" v-show="shcygnStep == 5 && !mouseFocusFZI" class="img-base" :src="require('@/assets/images/newestqianniu/shcygn8.png')" />
							<img style="height: 681.5px;" v-show="shcygnStep == 5 && mouseFocusFZI" class="img-base" :src="require('@/assets/images/newestqianniu/shcygn9.png')" />
							<div v-show="shcygnStep == 5" class="btn5"  @mouseenter="mouseFocusFZI = true" @mouseleave="mouseFocusFZI = false" @click="sevenStepEnd">&nbsp;</div>
							<img style="height: 681.5px;" v-show="shcygnStep == 6" class="img-base" :src="require('@/assets/images/newestqianniu/shcygn10.png')" />
						</div>
					</div>
					<div class="con-right">
						<h3>
							<span class="line"></span>
							提示
						</h3>
						<p v-if="shcygnStep == 1">请进入<span class="red-span">工作台</span></p>
						<p v-if="shcygnStep == 2 || shcygnStep == 3">请进入<span class="red-span">交易→已卖出宝贝</span></p>
						<p v-if="shcygnStep == 4">请进入<span class="red-span">评价管理</span></p>
						<p v-if="shcygnStep == 5 || shcygnStep == 6">请进入<span class="red-span">退款管理</span></p>
					</div>
				</div>
				<div id="studytip-seven" class="stoptip">
					<div class="tip">
						<span class="el-icon-success"></span>
						<p>实操通关，进入下一关吧</p>
						<p>
							<a class="restart" @click="restartStudySeven"><i class="el-icon-refresh-left"></i>重练</a>
							<a class="startstudy" @click="studyNext('#tab-eight')">GO，下一关</a>
						</p>
					</div>
				</div>
				<div class="study-box">
					<h3>
						<span class="line"></span>
						查看学习资料
					</h3>
					<el-row>
						<el-col :span="20">
							<img class="img-box" :src="require('@/assets/images/newqianniu/ppt.png')"/>
							<div class="con-box">
								<p>千牛练习-售后客服常用功能.ppt</p>
								<p>
									<a v-if="isOpenPpt7" class="btn-open" @click="viewPpt7(false)">点击收起</a>
									<a v-else class="btn-open" @click="viewPpt7">点击展开</a>
								</p>
							</div>
						</el-col>
						<el-col :span="4">
							<el-button v-if="isShowBtn[tabCurrent]" type="primary" class="pull-right startbtn"
								@click="startStudy">开始练习</el-button>
						</el-col>
					</el-row>
					<div id="pdf_viewer7"></div>
				</div>
			</el-tab-pane>
			<!--第8步 退出千牛-->
			<el-tab-pane name="eight">
				<div slot="label" class="tab-slot">
					<p class="title">9、退出千牛</p>
					<div class="hover-con">
						<p><i class="el-icon-video-play"></i></p>
						<p>点击学习</p>
					</div>
				</div>
				<div id="video-eight" class="video-box">
					<video id="eight" src="http://taojinyun.file.itaojin.cn/qianniusource/202412/step8.mp4"
						controls="controls" class="video">
						您的浏览器不支持 video 标签。
					</video>
					<div class="video-mask"></div>
				</div>
				<div id="stoptip-eight" class="stoptip">
					<div class="tip">
						<span class="el-icon-success"></span>
						<p>视频学习完毕，根据提示实操练习</p>
						<p>
							<a class="restart" @click="restartVideo"><i class="el-icon-refresh-left"></i>重播</a>
							<a class="startstudy" @click="startStudy">开始实操练习</a>
						</p>
					</div>
				</div>
				<div id="content-eight" class="content">
					<div class="con-left">
						<div class="tcqn">
							<img v-show="tcqnStep == 1" class="img-base" :src="require('@/assets/images/newestqianniu/tcqn1.png')" />
							<div v-show="tcqnStep == 1" class="btn1"  @click="tcqnStep = 2">&nbsp;</div>
							<img v-show="tcqnStep == 2 && !mouseFocus" class="img-base" :src="require('@/assets/images/newestqianniu/tcqn2.png')" />
							<img v-show="tcqnStep == 2 && mouseFocus" class="img-base" :src="require('@/assets/images/newestqianniu/tcqn3.png')" />
							<div v-show="tcqnStep == 2" class="btn2"  @mouseenter="mouseFocus = true" @mouseleave="mouseFocus = false" @click="tcqnStep = 3">&nbsp;</div>
							<img v-show="tcqnStep == 3" class="img-base" :src="require('@/assets/images/newestqianniu/tcqn4.png')" />
							<div v-show="tcqnStep == 3" class="btn3"  @click="tcqnStep = 4">&nbsp;</div>
							<img v-show="tcqnStep == 4" class="img-base" :src="require('@/assets/images/newestqianniu/tcqn5.png')" />
							<div v-show="tcqnStep == 4" class="btn1"  @click="tcqnStep = 5">&nbsp;</div>
							<img v-show="tcqnStep == 5 && !mouseFocusFZ" class="img-base" :src="require('@/assets/images/newestqianniu/tcqn6.png')" />
							<img v-show="tcqnStep == 5 && mouseFocusFZ" class="img-base" :src="require('@/assets/images/newestqianniu/tcqn7.png')" />
							<div v-show="tcqnStep == 5" class="btn4"  @mouseenter="mouseFocusFZ = true" @mouseleave="mouseFocusFZ = false" @click="tcqnStep = 6">&nbsp;</div>
							<img v-show="tcqnStep == 6" class="img-base" :src="require('@/assets/images/newestqianniu/tcqn8.png')" />
							<div v-show="tcqnStep == 6" class="btn5"  @click="eightStepEnd">&nbsp;</div>
							<!-- <img style="height: 681.5px;" v-show="tcqnStep == 7" class="img-base" :src="require('@/assets/images/newestqianniu/tcqn9.png')" /> -->
						</div>
					</div>
					<div class="con-right">
						<h3>
							<span class="line"></span>
							提示
						</h3>
						<p>请将状态切换为<span class="red-span">挂起，再退出千牛</span></p>
					</div>
				</div>
				<div id="studytip-eight" class="stoptip">
					<div class="tip">
						<span class="el-icon-success"></span>
						<div v-if="examNum" style="margin-top:5px;">
                            你已完成
                            <b style="color:#66B1FF">{{myExamNum}}</b>
                            次，需完成
                            <b style="color:#66B1FF">{{examNum}}</b>
                            次
						</div>
						<div style="margin-top:5px;">你已完成千牛的功能学习，</div>
						<div style="margin-top:5px;" v-if="!examNum || myExamNum >= examNum">接下来请完成《千牛模拟实操》。</div>
						<a class="startstudy" v-if="!examNum || myExamNum >= examNum" @click="goExam" style="width: 160px;margin-top:5px;">去完成千牛模拟实操</a>
						<a class="startstudy" v-else @click="goExam" style="width: 160px;">继续学习</a>
					</div>
				</div>
				<div class="study-box">
					<h3>
						<span class="line"></span>
						查看学习资料
					</h3>
					<el-row>
						<el-col :span="20">
							<img class="img-box" :src="require('@/assets/images/newqianniu/ppt.png')"/>
							<div class="con-box">
								<p>千牛练习-退出千牛.ppt</p>
								<p>
									<a v-if="isOpenPpt8" class="btn-open" @click="viewPpt8(false)">点击收起</a>
									<a v-else class="btn-open" @click="viewPpt8">点击展开</a>
								</p>
							</div>
						</el-col>
						<el-col :span="4">
							<el-button v-if="isShowBtn[tabCurrent]" type="primary" class="pull-right startbtn"
								@click="startStudy">开始练习</el-button>
						</el-col>
					</el-row>
					<div id="pdf_viewer8"></div>
				</div>
			</el-tab-pane>
		</el-tabs>
	</div>
</template>

<script>
import PDFObject from '../../../assets/js/pdfobject.min'
export default {
	data() {
		return {
            myExamNum : null,//我的完成次数
            nextCourseId : null,//下个课程，一般用于 功能学习的，下个课程
            examNum:null,
			tabIndex: 0, //序号
			tabCurrent: 'zero', //当前标签页
			isShowBtn: [], //是否显示开始练习按钮
			isOpenPpt: false, //是否展开ppt
			isOpenPpt2: false, //是否展开ppt
			isOpenPpt3: false, //是否展开ppt
			isOpenPpt4: false, //是否展开ppt
			isOpenPpt5: false, //是否展开ppt
			isOpenPpt6: false, //是否展开ppt
            isOpenPpt61: false, //是否展开ppt
			isOpenPpt7: false, //是否展开ppt
			isOpenPpt8: false, //是否展开ppt
			//第1步
			isShowQnIcon: true, //是否显示千牛图标
			isShowQnIcon2: false, //显示点击千牛图标后图片
			isShowLoginImg: false, //是否显示登录图片
			mouseFocusSaveAP: false, //鼠标焦点
			isSaveAP: false, //是否保存账号密码
			name: '', //登录账号
			password: '', //密码
			showPassword: false, //显示账号密码
			isShowRnd: false, //显示获取随机码
			rnd: '', //随机密码
			mouseFocusRnd: false, //鼠标焦点
			showRnd: false, //显示随机码
			isShowLoginIndex: false, //显示登录后图片
			mouseFocusJD: false, //鼠标焦点
			isShowLoginIndexTwo: false, //显示接待中心
			//第2步
			gqstep: 1, //挂起步骤
			wgqstep: 1,
			mouseFocusZX: false, //鼠标焦点
			mouseFocusGQ: false,
			mouseFocusDdsc: false,
			mouseFocusSet: false,
			mouseFocusSetInfo: false,
			mouseFocusSetInfoDetail: false,
			secondStep: 1,
			secondStepStep: 1,
			//第3步---------
			kjdyStep:1,
			kjdySearch:'',
			mouseFocusKJDY:false,
			mouseFocusFZ:false,
			mouseFocusFZI:false,
			kjdybm: '',
			kjdynr: '',
			kjdyfz: '',
			kjdyfs: '',
			//第4步---------
			cygnStep: 1,
			mouseFocus: false,
			zjyy: '',
			//第5步---------
			zncjsstep: 1,
			//第6步---------
			zncjxstep: 1,
			showYfstep: false,
			yfamount:'0',
			bznr: '',
			phone: '18418966473-4839',
            //第7（6-1）步---------
            qtcjStep: 1,
            gfkf: '',
			//第8步---------
			shcygnStep: 1,
			//第9步---------
			tcqnStep: 1,
		}
	},
	mounted() {
		document.getElementById(this.tabCurrent).addEventListener('ended', () => { //该视频播放是否已结束
			$('#startvideo').hide();
			$('#stoptip-' + this.tabCurrent).show();
			this.$set(this.isShowBtn, this.tabCurrent, true)
		}, false);
		document.getElementById(this.tabCurrent).addEventListener('play', () => { //该视频播放是否已结束
			$('#startvideo').hide();
		}, false);
	},
	directives: {
		focus: {
			inserted: function (el, { value }) {
				if (value) {
					el.focus();
				}
			}
		}
	},
	methods: {
		back() {
            this.$router.back();
		},
		goExam() {
		    if(this.examNum && this.myExamNum >= this.examNum){
		        if(this.nextCourseId){
            		this.$router.replace({ name: 'fbtQianniuExam', query:{courseId:this.nextCourseId}});
                }else{
                    this.$router.back();
				}
            }else{
                location.reload()
			}
        },
		resetFocus() {
			this.mouseFocus = false
			this.mouseFocusZX = false
			this.mouseFocusGQ = false
			this.mouseFocusDdsc = false
			this.mouseFocusSet = false
			this.mouseFocusSetInfo = false
			this.mouseFocusSetInfoDetail = false
			this.mouseFocusKJDY = false
			this.mouseFocusFZ = false
			this.mouseFocusFZI = false
			this.mouseFocusSaveAP = false
			this.mouseFocusRnd = false
			this.mouseFocusJD = false
		},
		//&&*************第三步的内容*****/
		kjdyfsChange(e) {
			if (e == '/欢迎') {
				this.kjdyStep = 15
			}
		},
		enterSelect() {
			this.kjdyStep = 16
			const self = this
			this.$nextTick(() => {
				this.$refs.sixInput.focus();
			});
		},
		tirggerFile($event) {
			let self = this
			var file = $event.target.files;
			if (!file[0] || file[0] && file[0].name.indexOf('快捷短语') < 0) {
				this.$alert('请选择你下载的"快捷短语.csv"模板文件')
				return false
			}
			const fileInput = this.$refs.fileInput;
			setTimeout(function () {
				fileInput.value = "";
				self.kjdyStep = 11
			}, 500);
		},
		kjdyConfirm() {
			if (this.kjdynr != '亲，欢迎光临，请问有什么可以帮您的？') {
				this.$alert('请输入正确的快捷短语内容！')
				return
			}
			if (this.kjdybm != '欢迎') {
				this.$alert('请输入正确的编码')
				return
			}
			this.kjdyStep = 9
		},
		kjdySearchChange() {
			if (this.kjdySearch == '淘金云客服:小淘') {
				const self = this
				setTimeout(() => {
					self.kjdyStep = 2
				}, 500);
			}
		},
		kjdyfzConfirm() {
			if (this.kjdyfz == '开头语') {
				this.kjdyStep = 8
				return
			}
			this.$alert('分组名称应为: 开头语')
		},
		//********第四步的内容**********/
		fourStepBystep() {
			this.cygnStep = 3
			const self = this
			setTimeout(() => {
				self.cygnStep = 4
			}, 2500);
		},
		sendZfyy() {
			if (this.zjyy == '少件') {
				this.cygnStep = 7
				let self = this;
				this.addRecord('END')
				setTimeout(function () {
						$('#studytip-' + self.tabCurrent).show();
				}, 2000);
				return
			}
			this.$alert('请输入正确的转交原因');
		},
		//********第5步的内容**********/
		tjspEnd() {
			this.zncjsstep = 3
			let self = this;
			this.addRecord('END')
			setTimeout(function () {
				$('#studytip-' + self.tabCurrent).show();
			}, 2000);
		},
		/********第6步的内*********/
		sixStepByStep() {
			this.zncjxstep = 4	
			const self = this
			setTimeout(() => {
				self.zncjxstep = 5
			}, 2500);
		},
		sixStepByStep2() {
			this.zncjxstep = 6
			const self = this
			setTimeout(() => {
				self.zncjxstep = 7
			}, 2500);
		},
		sixStepByStep3(){
			if (this.yfamount == 8) {
				this.showYfstep = false
				this.yfamount = ''
				this.zncjxstep = 8
				return
			}
			this.$alert('请输入正确的邮费');
		},
		sixStepByStep4(){
			if (this.bznr == '发顺丰') {
				this.bznr = ''
				this.zncjxstep = 11
				const self = this
				setTimeout(() => {
					self.zncjxstep = 12
				}, 2500);
				return
			}
			this.$alert('请输入正确的备注');
		},
		sixStepByStep5(){
			this.zncjxstep = 13
			const self = this
			setTimeout(() => {
				self.zncjxstep = 14
			}, 2500);
		},
		sixStepByStep6(){
			if (this.phone == '13656565656') {
				this.zncjxstep = 16
				let self = this;
				this.addRecord('END')
				setTimeout(function () {
					$('#studytip-' + self.tabCurrent).show();
				}, 2000);
				return
			}
			this.$alert('请输入正确的电话号码！');
		},
        six1StepEnd() {
			let self = this;
			this.addRecord('END')
			setTimeout(function () {
				$('#studytip-' + self.tabCurrent).show();
			}, 2000);
        },
		/********第7 8步的内*********/
		sevenStepEnd() {
			this.shcygnStep = 6
			let self = this;
			this.addRecord('END')
			setTimeout(function () {
				$('#studytip-' + self.tabCurrent).show();
			}, 2000);
		},
		eightStepEnd() {
			this.tcqnStep = 7
			let self = this;
			this.addRecord('END')
			setTimeout(function () {
				$('#studytip-' + self.tabCurrent).show();
			}, 2000);
		},
		/******************/
		formatDate: function (value) {
			let date = new Date(value);
			let y = date.getFullYear();
			let MM = date.getMonth() + 1;
			MM = MM < 10 ? ('0' + MM) : MM;
			let d = date.getDate();
			d = d < 10 ? ('0' + d) : d;
			let h = date.getHours();
			h = h < 10 ? ('0' + h) : h;
			let m = date.getMinutes();
			m = m < 10 ? ('0' + m) : m;
			let s = date.getSeconds();
			s = s < 10 ? ('0' + s) : s;
			return y + '-' + MM + '-' + d + ' ' + h + ':' + m + ':' + s;
		},
		//第1步-开始播放视频
		startVideo() {
			document.getElementById('zero').play();
			$('#startvideo').hide();
		},
		//初始化第1步状态值
		initFirst() {
			this.isSaveAP = false; //是否保存账号密码
			this.name = ''
			this.password = ''
			this.rnd = ''
			this.isShowQnIcon = true
			this.isShowQnIcon2 = false
			this.isShowLoginImg = false
			this.showPassword = false
			this.isShowRnd = false
			this.showRnd = false
			this.isShowLoginIndex = false
			this.isShowLoginIndexTwo = false
		},
		//初始化第2步状态值
		initSecond() {
			this.gqstep = 1 //挂起步骤
			this.wgqstep = 1 //未挂起步骤
			this.secondStep = 1
			this.secondStepStep = 1
		},
		//初始化第3步状态值
		initThird() {
			this.kjdyStep = 1
			this.kjdySearch = ''
			this.mouseFocusKJDY = false
			this.mouseFocusFZ = false
			this.mouseFocusFZI = false
			this.kjdybm = ''
			this.kjdynr = ''
			this.kjdyfz = ''
			this.kjdyfs = ''
		},
		//初始化第4步状态值
		initFour() {
			this.cygnStep = 1
			this.zjyy = ''
		},
		//初始化第5步状态值
		initFive() {
			this.zncjsstep = 1
		},
		//初始化第6步状态值
		initSix() {
			this.zncjxstep = 1
			this.showYfstep = false
			this.yfamount = '0'
			this.bznr = ''
			this.phone = '18418966473-4839'
		},
        //初始化第6-1步状态值
		initSix1() {
			this.qtcjStep = 1
            this.gfkf = null
		},
		//初始化第7步状态值
		initSeven() {
			this.shcygnStep = 1
		},
		//初始化第8步状态值
		initEight() {
			this.tcqnStep = 1
		},
		
		//初始化所有tab内容
		initAll() {
			$('#startvideo').hide();
			this.isShowBtn = []
			this.isOpenPpt = false
			this.isOpenPpt2 = false
			this.isOpenPpt3 = false
			this.isOpenPpt4 = false
			this.isOpenPpt5 = false
			this.isOpenPpt6 = false
			this.isOpenPpt61 = false
			this.isOpenPpt7 = false
			this.isOpenPpt8 = false
			$('#pdf_viewer').height('0');
			$('#pdf_viewer1').height('0');
			$('#pdf_viewer2').height('0');
			$('#pdf_viewer3').height('0');
			$('#pdf_viewer4').height('0');
			$('#pdf_viewer5').height('0');
			$('#pdf_viewer6').height('0');
			$('#pdf_viewer61').height('0');
			$('#pdf_viewer7').height('0');
			$('#pdf_viewer8').height('0');
			//第1步
			this.initFirst()
			//第2步
			this.initSecond()
			//第3步
			this.initThird()
			//第4步
			this.initFour()
			//第5步
			this.initFive()
			//第6步
			this.initSix()
			//第6-1步
			this.initSix1()
			//第7步
			this.initSeven()
			//第8步
			this.initEight()
			$('.content').each(function (i) {
				$(this).hide();
			});
			$('.stoptip').each(function (i) {
				$(this).hide();
			});
			$('.video-box').not('#video-' + this.tabCurrent).each(function (i) {
				$(this).hide();
			});
			$('#video-' + this.tabCurrent).show();
		},
		//tab切换
		handleClick(tab, event) {
			this.tabIndex = parseInt(tab.index)
			//内容初始化
			this.initAll();
			this.resetFocus();
			document.getElementById(this.tabCurrent).play();
			$('video').not('#' + this.tabCurrent).each(function (i) {
				var tabId = $(this).attr('id');
				document.getElementById(tabId).pause();
				document.getElementById(tabId).currentTime = 0;
			});
			document.getElementById(this.tabCurrent).addEventListener('ended', () => { //该视频播放是否已结束
				$('#stoptip-' + this.tabCurrent).show();
				this.$set(this.isShowBtn, this.tabCurrent, true);
			}, false);
		},
		//展开/收起ppt
		viewPpt(bol) {
			if (this.isOpenPpt == true || !bol) {
				this.isOpenPpt = false
				$('#pdf_viewer').height('0');
			} else {
				this.isOpenPpt = true
				var options = {
					pdfOpenParams: {
						navpanes: 0,
						toolbar: 0,
						statusbar: 0,
						view: "FitV",
						pagemode: "thumbs",
						page: 1
					},
					forcePDFJS: true,
					PDFJS_URL: "//cmain.static.itaojin.cn/static/main/scripts/vendor/PDFjs/generic/web/viewer.html"
				};
				if (PDFObject.supportsPDFs) {
					$('#pdf_viewer').height('700px');
					PDFObject.embed('//res.study.itaojin.cn/2024-12/661361ebec2f434fb859625f84480ea0.pdf', "#pdf_viewer", options)
				}
			}
		},
		//展开/收起ppt
		viewPpt2(bol) {
			if (this.isOpenPpt2 == true || !bol) {
				this.isOpenPpt2 = false
				$('#pdf_viewer2').height('0');
			} else {
				this.isOpenPpt2 = true
				var options = {
					pdfOpenParams: {
						navpanes: 0,
						toolbar: 0,
						statusbar: 0,
						view: "FitV",
						pagemode: "thumbs",
						page: 1
					},
					forcePDFJS: true,
					PDFJS_URL: "//cmain.static.itaojin.cn/static/main/scripts/vendor/PDFjs/generic/web/viewer.html"
				};
				if (PDFObject.supportsPDFs) {
					$('#pdf_viewer2').height('700px');
					PDFObject.embed('//res.study.itaojin.cn/2024-12/e203c6b30e9049818094cee869c17026.pdf', "#pdf_viewer2", options)
				}
			}
		},
		//展开/收起ppt
		viewPpt3(bol) {
			if (this.isOpenPpt3 == true || !bol) {
				this.isOpenPpt3 = false
				$('#pdf_viewer3').height('0');
			} else {
				this.isOpenPpt3 = true
				var options = {
					pdfOpenParams: {
						navpanes: 0,
						toolbar: 0,
						statusbar: 0,
						view: "FitV",
						pagemode: "thumbs",
						page: 1
					},
					forcePDFJS: true,
					PDFJS_URL: "//cmain.static.itaojin.cn/static/main/scripts/vendor/PDFjs/generic/web/viewer.html"
				};
				if (PDFObject.supportsPDFs) {
					$('#pdf_viewer3').height('700px');
					PDFObject.embed('//res.study.itaojin.cn/2024-12/6fa4070d7418446690ce19576261afe5.pdf ', "#pdf_viewer3", options)
				}
			}
		},
		//展开/收起ppt
		viewPpt4(bol) {
			if (this.isOpenPpt4 == true || !bol) {
				this.isOpenPpt4 = false
				$('#pdf_viewer4').height('0');
			} else {
				this.isOpenPpt4 = true
				var options = {
					pdfOpenParams: {
						navpanes: 0,
						toolbar: 0,
						statusbar: 0,
						view: "FitV",
						pagemode: "thumbs",
						page: 1
					},
					forcePDFJS: true,
					PDFJS_URL: "//cmain.static.itaojin.cn/static/main/scripts/vendor/PDFjs/generic/web/viewer.html"
				};
				if (PDFObject.supportsPDFs) {
					$('#pdf_viewer4').height('700px');
					PDFObject.embed('//res.study.itaojin.cn/2024-12/8a2815e9246840c2be40e87ac705da18.pdf', "#pdf_viewer4", options)
				}
			}
		},
		//展开/收起ppt
		viewPpt5(bol) {
			if (this.isOpenPpt5 == true || !bol) {
				this.isOpenPpt5 = false
				$('#pdf_viewer5').height('0');
			} else {
				this.isOpenPpt5 = true
				var options = {
					pdfOpenParams: {
						navpanes: 0,
						toolbar: 0,
						statusbar: 0,
						view: "FitV",
						pagemode: "thumbs",
						page: 1
					},
					forcePDFJS: true,
					PDFJS_URL: "//cmain.static.itaojin.cn/static/main/scripts/vendor/PDFjs/generic/web/viewer.html"
				};
				if (PDFObject.supportsPDFs) {
					$('#pdf_viewer5').height('700px');
					PDFObject.embed('//res.study.itaojin.cn/2024-12/52d4b0fc262c4b058ddee379d625552f.pdf', "#pdf_viewer5", options)
				}
			}
		},
		//展开/收起ppt
		viewPpt6(bol) {
			if (this.isOpenPpt6 == true || !bol) {
				this.isOpenPpt6 = false
				$('#pdf_viewer6').height('0');
			} else {
				this.isOpenPpt6 = true
				var options = {
					pdfOpenParams: {
						navpanes: 0,
						toolbar: 0,
						statusbar: 0,
						view: "FitV",
						pagemode: "thumbs",
						page: 1
					},
					forcePDFJS: true,
					PDFJS_URL: "//cmain.static.itaojin.cn/static/main/scripts/vendor/PDFjs/generic/web/viewer.html"
				};
				if (PDFObject.supportsPDFs) {
					$('#pdf_viewer6').height('700px');
					PDFObject.embed('//res.study.itaojin.cn/2024-12/5490dc4ddc6c4e73897aaa3332e5a3d1.pdf', "#pdf_viewer6", options)
				}
			}
		},
        //展开/收起ppt
		viewPpt61(bol) {
			if (this.isOpenPpt61 == true || !bol) {
				this.isOpenPpt61 = false
				$('#pdf_viewer61').height('0');
			} else {
				this.isOpenPpt61 = true
				var options = {
					pdfOpenParams: {
						navpanes: 0,
						toolbar: 0,
						statusbar: 0,
						view: "FitV",
						pagemode: "thumbs",
						page: 1
					},
					forcePDFJS: true,
					PDFJS_URL: "//cmain.static.itaojin.cn/static/main/scripts/vendor/PDFjs/generic/web/viewer.html"
				};
				if (PDFObject.supportsPDFs) {
					$('#pdf_viewer61').height('700px');
					PDFObject.embed('//res.study.itaojin.cn/2024-12/%E6%B7%BB%E5%8A%A0%E5%85%B6%E4%BB%96%E6%8F%92%E4%BB%B6-%E5%B0%8F%E5%8A%A9%E6%89%8B%E4%B8%8A%E8%AF%BE%E4%BB%B6.pdf', "#pdf_viewer61", options)
				}
			}
		},

		//展开/收起ppt
		viewPpt7(bol) {
			if (this.isOpenPpt7 == true || !bol) {
				this.isOpenPpt7 = false
				$('#pdf_viewer7').height('0');
			} else {
				this.isOpenPpt7 = true
				var options = {
					pdfOpenParams: {
						navpanes: 0,
						toolbar: 0,
						statusbar: 0,
						view: "FitV",
						pagemode: "thumbs",
						page: 1
					},
					forcePDFJS: true,
					PDFJS_URL: "//cmain.static.itaojin.cn/static/main/scripts/vendor/PDFjs/generic/web/viewer.html"
				};
				if (PDFObject.supportsPDFs) {
					$('#pdf_viewer7').height('700px');
					PDFObject.embed('//res.study.itaojin.cn/2024-12/4183c223f03d4892a6768486996d5455.pdf', "#pdf_viewer7", options)
				}
			}
		},
		//展开/收起ppt
		viewPpt8(bol) {
			if (this.isOpenPpt8 == true || !bol) {
				this.isOpenPpt8 = false
				$('#pdf_viewer8').height('0');
			} else {
				this.isOpenPpt8 = true
				var options = {
					pdfOpenParams: {
						navpanes: 0,
						toolbar: 0,
						statusbar: 0,
						view: "FitV",
						pagemode: "thumbs",
						page: 1
					},
					forcePDFJS: true,
					PDFJS_URL: "//cmain.static.itaojin.cn/static/main/scripts/vendor/PDFjs/generic/web/viewer.html"
				};
				if (PDFObject.supportsPDFs) {
					$('#pdf_viewer8').height('700px');
					PDFObject.embed('//res.study.itaojin.cn/2024-12/d138c13a5f304a0198294afb2495384b.pdf', "#pdf_viewer8", options)
				}
			}
		},
		
		//重播
		restartVideo() {
			document.getElementById(this.tabCurrent).play();
			$('#stoptip-' + this.tabCurrent).hide();
		},
		//开始实操练习
		startStudy() {
			document.getElementById(this.tabCurrent).pause();
			$('#stoptip-' + this.tabCurrent).hide();
			$('#video-' + this.tabCurrent).hide();
			this.isShowBtn[this.tabCurrent] = false
			$('#content-' + this.tabCurrent).show();
			this.addRecord('START')
		},
		//下一关
		studyNext(next) {
			this.initFirst()
			this.initSecond()
			this.initThird()
			this.initFour()
			this.initFive()
			this.initSix()
			this.initSix1()
			this.initSeven()
			this.initEight()
			this.resetFocus()
			$('#studytip-' + this.tabCurrent).hide();
			$('#content-' + this.tabCurrent).hide();
			$('#video-' + this.tabCurrent).show();
			document.getElementById(this.tabCurrent).currentTime = 0
			$(next).click();
		},
		//第1步-单击千牛图标
		showLoginImg() {
			this.isShowQnIcon = false
			this.isShowQnIcon2 = true
		},
		//双击千牛图标
		showLoginImg2(event) {
			event.preventDefault(); 
			this.isShowQnIcon2 = false
			this.isShowLoginImg = true
		},
		//登录
		loginIn() {
			if (this.name == '') {
				this.notify('<p>请输入账号</p>')
				return
			} else if (this.name != '淘金云客服:小淘') {
				this.notify('<p>用户名或密码错误</p>' + '<p>请注意大小写或特殊符号</p>')
				return
			}
			if (this.password == '') {
				this.notify('<p>请输入密码</p>')
				return
			} else if (this.password != 'Tj1234') {
				this.notify('<p>用户名或密码错误</p>' + '<p>请注意大小写或特殊符号</p>')
				return
			}
			this.isShowLoginImg = false
			this.isShowRnd = true
		},
		//验证码登录
		loginInRnd() {
			if (this.rnd == '') {
				this.notify('<p>请输入短信验证码</p>')
				return
			} else if (this.rnd != '660220') {
				this.notify('<p>短信验证码错误</p>')
				return
			}
			this.isShowRnd = false
			this.isShowLoginIndex = true
		},
		//进入接待中心
		enterJd() {
			var self = this
			this.isShowLoginIndex = false
			this.isShowLoginIndexTwo = true
			this.addRecord('END')
			setTimeout(function () {
				$('#studytip-' + self.tabCurrent).show();
			}, 2000);
		},
		//第2步-切换状态-显示未挂起图片
		showGqImgClick() {
			this.secondStepStep = 5
			this.addRecord('END')
			var self = this
			setTimeout(function () {
				$('#studytip-' + self.tabCurrent).show();
			}, 2000);
		},
		finishThird() {
			this.kjdyStep = 17
			this.addRecord('END')
			var self = this
			setTimeout(function () {
				$('#studytip-' + self.tabCurrent).show();
			}, 2000);
		},
		downloadKjdyFile() {
			this.downCount = 1
			let path = '//taojinyun.file.itaojin.cn/qianniusource/快捷短语.csv'
			const downloadRes = async () => {
				let response = await fetch(path);
				let blob = await response.blob();
				let objectUrl = window.URL.createObjectURL(blob);
				let a = document.createElement('a');
				a.href = objectUrl;
				a.download = '快捷短语.csv';
				a.click()
				a.remove();
			}
			downloadRes();
		},

		restartStudyFirst() {
			this.initFirst()
			this.resetFocus()
			$('#studytip-' + this.tabCurrent).hide();
			this.addRecord('START')
		},
		restartStudySecond() {
			this.initSecond()
			this.resetFocus()
			$('#studytip-' + this.tabCurrent).hide();
			this.addRecord('START')
		},
		restartStudyThird() {
			this.initThird()
			this.resetFocus()
			$('#studytip-' + this.tabCurrent).hide();
			this.addRecord('START')
		},
		restartStudyFour() {
			this.initFour()
			this.resetFocus()
			$('#studytip-' + this.tabCurrent).hide();
			this.addRecord('START')
		},
		restartStudyFive() {
			this.initFive()
			this.resetFocus()
			$('#studytip-' + this.tabCurrent).hide();
			this.addRecord('START')
		},
		restartStudySix() {
			this.initSix()
			this.resetFocus()
			$('#studytip-' + this.tabCurrent).hide();
			this.addRecord('START')
		},
		restartStudySix1() {
			this.initSix1()
			this.resetFocus()
			$('#studytip-' + this.tabCurrent).hide();
			this.addRecord('START')
		},
		restartStudySeven() {
			this.initSeven()
			this.resetFocus()
			$('#studytip-' + this.tabCurrent).hide();
			this.addRecord('START')
		},
		restartStudyEight() {
			this.initEight()
			this.resetFocus()
			$('#studytip-' + this.tabCurrent).hide();
			this.addRecord('START')
		},
		/*
		 * @description 时间格式化
		 * @param { date } date 时间或时间戳
		 * @param { string } format 格式化的字符串 eg: 'yyyy:MM:dd hh:mm:ss'
		 *
		 * @return { string } 格式化后的字符串
		*/
		dateFormatString(date, format) { // 时间格式化
			var date = new Date(date),
				o = {
					"M+": date.getMonth() + 1,
					"d+": date.getDate(),
					"h+": date.getHours(),
					"m+": date.getMinutes(),
					"s+": date.getSeconds(),
					"q+": Math.floor((date.getMonth() + 3) / 3),
					"S": date.getMilliseconds()
				};
			if (/(y+)/.test(format)) {
				format = format.replace(RegExp.$1, (date.getFullYear() + "").substr(4 - RegExp.$1.length));
			}

			for (var k in o) {
				if (new RegExp("(" + k + ")").test(format)) {
					format = format.replace(RegExp.$1, RegExp.$1.length == 1 ? o[k] : ("00" + o[k]).substr(("" + o[k]).length));
				}
			}
			return format;
		},
		/**
		 * 获取从今日开始的前 n 天的日期
		 */
		getLastDaysFromToday(n) {
			let lastDays = new Date().setDate((new Date().getDate() - n));
			let lastDaysStr = this.dateFormatString(lastDays, 'yyyy-MM-dd');
			return lastDaysStr;
		},
		//记录接口
		addRecord(type) {
			var data = {
				exerciseType: "QIANNIU_PLUGIN",
				stepSeq: this.tabIndex,
				exerciseAction: type
			}
			this.$http.post(API_ROOT.newcustomer + '/simulationExercise/addRecord', data).then(res => {
				var result = res.data
				if (result.success) {
					if (this.tabIndex == 9 && type == 'END') {
                        this.queryFinishInfo();
					}
				} else {
                    this.$message({message: result.msg,type: 'error',center: true,duration: 2000})
				}
			}, res => {
                this.$message({message: "网络繁忙，请稍后重试！", type: 'error',center: true,duration: 1500})
			})
		},
		//查，完成了几次
        queryFinishInfo() {
            var query = {
                assitantType: "qianniuplugin",
				courseId:this.$route.query.courseId
            }
            this.$http.post(API_ROOT.college + '/majors/queryFinishInfo', query).then(res => {
                var result = res.data
                if (result.success) {
                    this.myExamNum = result.data.examNum;
                    this.examNum = result.data.targetPassCnt;
                    this.nextCourseId = result.data.nextCourseId;
                } else {
                    this.$message({message: result.msg,type: 'error',center: true,duration: 2000})
                }
            }, res => {
                this.$message({message: "网络繁忙，请稍后重试！", type: 'error',center: true,duration: 1500})
            })
        },
        onGfkfInput() {
            if (this.gfkf && this.gfkf.trim() === '天猫官方客服') {
                this.qtcjStep = 2;
            }
        },
	}
}
</script>
<style lang="less" scoped>
.account-table {
	border-top: 1px solid #000000;
	border-left: 1px solid #000000;
	margin: 10px;
	border-spacing: inherit;

	>tr>td {
		border-right: 1px solid #000000;
		border-bottom: 1px solid #000000;
		padding: 5px;
	}
}
.red-span {
	color: red;
	font-weight:bold;
}
.video-mask {
	position: absolute;
	bottom: 0;
	left: 0px;
	width:1350px;
	height: 25px;
}
</style>


// WEBPACK FOOTER //
// ./src/page/train/FBT/qianniu.vue